import Lucide from '@/components/Base/Lucide'
import Notification from '@/components/Base/Notification'
import React from 'react'
import { useTranslation } from 'react-i18next';

export default function NotificationAlert() {
    const { t } = useTranslation();
    
    return (
        <>
            <Notification id="success" className="flex">
                <Lucide icon="CheckCircle" className="text-success" />
                <div className="ml-4 mr-4">
                    <div className="font-medium">{t("success")}</div>
                </div>
            </Notification>

            <Notification id="failed-accept" className="flex">
                <Lucide icon="XCircle" className="text-danger" />
                <div className="ml-4 mr-4">
                    <div className="font-medium">{t("acceptFail")}</div>
                </div>
            </Notification>

            <Notification id="failed-connection" className="flex">
                <Lucide icon="XCircle" className="text-danger" />
                <div className="ml-4 mr-4">
                    <div className="font-medium">{t("failedConnection")}</div>
                </div>
            </Notification>
        </>
    )
}
